import {ASync} from "../PA.Core/Basic/ASync";
import {IPolicy} from "../PA.Core/PA.Core.IF.Policy";
import {BehaviorSubject} from "rxjs";
import * as _ from 'lodash'
import {CustomColumnBO} from "../PA.MD.BusinessObjects/CustomColumnBO";
import {WB_CustomColumnRow} from "../PA.Core/PAdbSchemaRows";

import {PAEntity} from "../PA.Core/PAEntity";


export class CustomColumnPolicy
    implements IPolicy {
    _CustomColumn: CustomColumnBO
    _CustomColumnRow: WB_CustomColumnRow
    _PolicyChanged: BehaviorSubject<IPolicy>
    _bColumnGeneratedInd: boolean
    _isLoaded: boolean

    constructor(CustomColumn: CustomColumnBO) {
        this._CustomColumn = CustomColumn
        this._CustomColumnRow = CustomColumn.WB_CustomColumn
        this._PolicyChanged = new BehaviorSubject<IPolicy>(this)
        this._bColumnGeneratedInd = false
    }

    get OnLoadComplete(): Promise<void> {
        const self = this

        if (self._isLoaded) {
            return ASync.resolve()
        }

        return new Promise<any>((resolve, error) => {
            self._CustomColumn.OnLoadComplete
                .then((ignore) => {
                    return self.refreshPolicy()
                }).then((ignore) => {
                resolve(self)
            }).catch((err) => {
                error(err)
            })
        })
    }


    // Add Editbility/ Visibility Properties for all the Elements of an Event
    get bFieldEditable(): boolean {
        return !this._bColumnGeneratedInd;
    }


    get PolicyChanged(): BehaviorSubject<IPolicy> {
        return this._PolicyChanged
    }

    async refreshPolicy(): Promise<void> {
        const self = this

        if (self._isLoaded) {
            return
        }

        if (self._CustomColumn.WB_CustomColumn.cif.GENERATED_IND == '0' || _.isEmpty(self._CustomColumn.WB_CustomColumn.cif.GENERATED_IND)) {
            self._bColumnGeneratedInd = false;
            self._PolicyChanged.next(self)
            return
        }
        self._bColumnGeneratedInd = true;
        self._PolicyChanged.next(self)
        return
    }

}


